export default __webpack_public_path__ + "static/media/Dell_Logo.svg.3b1b87d6.png";